// extracted by mini-css-extract-plugin
module.exports = {"invoiceProductList":"FactorDetail_invoiceProductList__3CKMA","finalPriceTitle":"FactorDetail_finalPriceTitle__GtqWo","finalPrice":"FactorDetail_finalPrice__3pwLX"};